
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { CouriersService } from '../../../../services/courier-services/couriers.service';
import { PackageOption } from '../../../../models/inModels/MarketPlaceModel';

@Component({
  selector: 'app-edit-package',
  templateUrl: './edit-package.component.html',
})
export class EditPackageComponent implements OnInit {
  model: PackageOption;
  loading = false;
  error: Message[];
  messages: Message[];
  id;
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: CouriersService,) {
    this.model = new PackageOption();
  }

  ngOnInit() {
    this.loading = true;
    this.id = this.route.snapshot.params.Id;
    this.service.getPackageOption(this.id).then(
      res => {
        this.model = new PackageOption(res);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.messages = [];
        this.messages.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  goBack(): void {
    this.router.navigate(['/marketplace/courier-services/edit', this.model.CourierServiceId]);
  }

  save() {
    this.loading = true;
    this.service.updatePackageOption(this.model).then(
      res => {
        this.model = new PackageOption(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/courier-services/edit/edit-package/edit-package.component.ts